import api from './api';

class UserService {
  async updateHealthProfile(healthProfileData) {
    try {
      console.log('Updating health profile:', healthProfileData);
      const response = await api.put('/users/health-profile', healthProfileData);
      console.log('Health profile update response:', response);
      return response; // api.js already returns response.data
    } catch (error) {
      console.error('Error updating health profile:', error);
      console.error('Full error object:', {
        message: error.message,
        response: error.response,
        status: error.response?.status,
        data: error.response?.data
      });
      
      // Throw detailed validation errors if available
      if (error.response?.data) {
        const errorData = error.response.data;
        
        // If there are specific field errors, show them
        if (errorData.errors && Array.isArray(errorData.errors)) {
          const errorMessages = errorData.errors.map(err => 
            `${err.field}: ${err.message}`
          ).join('\n');
          throw new Error(`Validation failed:\n${errorMessages}`);
        }
        
        throw new Error(errorData.message || 'Failed to update health profile');
      }
      throw error;
    }
  }

  async getHealthProfile() {
    try {
      console.log('Fetching health profile...');
      const response = await api.get('/users/health-profile');
      console.log('Health profile fetch response:', response);
      return response;
    } catch (error) {
      console.error('Error fetching health profile:', error);
      throw error;
    }
  }

  async getCurrentUser() {
    try {
      console.log('Fetching current user...');
      const response = await api.get('/auth/me');
      console.log('Current user response:', response);
      return response.data;
    } catch (error) {
      console.error('Error fetching current user:', error);
      throw error;
    }
  }

  async updateUser(userData) {
    try {
      console.log('Updating user:', userData);
      const response = await api.put('/auth/profile', userData);
      console.log('User update response:', response);
      return response.data;
    } catch (error) {
      console.error('Error updating user:', error);
      throw error;
    }
  }

  async getUserStorage() {
    try {
      console.log('Fetching user storage...');
      const response = await api.get('/users/storage');
      console.log('User storage response:', response);
      return response.data;
    } catch (error) {
      console.error('Error fetching user storage:', error);
      throw error;
    }
  }

  async markOnboardingSeen() {
    try {
      console.log('Marking onboarding as seen...');
      const response = await api.post('/users/mark-onboarding-seen');
      console.log('Mark onboarding seen response:', response);
      return response.data;
    } catch (error) {
      console.error('Error marking onboarding as seen:', error);
      throw error;
    }
  }
}

const userService = new UserService();
export default userService;